<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="close"
            @close="close"
            @hidden="hidden"
        >

            <template #modal-title>
                Errors
            </template>

            <div v-if="errors && errors.length">
                <div class="d-flex align-items-center mb-3">
                    <div class="ml-auto">
                        <b-btn size="sm" variant="light" @click.prevent="clearAllErrors">
                            Clear All
                        </b-btn>
                    </div>
                </div>

                <b-list-group class="mb-3">
                    <b-list-group-item v-for="(error, index) in ordered_errors" :key="index">
                        <div class="d-flex align-items-center">
                            <div class="mr-3">
                                <!-- <div v-if="error">
                                    {{error}}
                                </div> -->
                                <div v-if="error.config && error.config.url" class="d-flex align-items-center mb-1 url">
                                    <div class="mr-2">
                                        <b-badge variant="secondary" tabindex="-1">{{error.config.url}}</b-badge>
                                    </div>
                                    <div class="copy-to-clipboard">
                                        <b-btn
                                            size="sm"
                                            variant="link"
                                            v-clipboard:copy="error.config.url"
                                        >
                                            <font-awesome-icon :icon="['fad', 'clipboard']" />
                                        </b-btn>
                                    </div>
                                </div>
                                <div v-if="error.data && error.data.message" class="message">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex align-items-center mr-2" tabindex="-1">
                                            <div v-if="error.data && error.data.errors" v-b-toggle="'error' + index" class="mr-1 collapse-icon">
                                                <span class="open">
                                                    <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                                                </span>
                                                <span class="closed">
                                                    <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                                                </span>
                                            </div>
                                            <div>
                                                <code class="text-danger">{{error.data.message}}</code>
                                            </div>
                                        </div>
                                        <div class="copy-to-clipboard">
                                            <b-btn
                                                size="sm"
                                                variant="link"
                                                v-clipboard:copy="error.data.message"
                                            >
                                                <font-awesome-icon :icon="['fad', 'clipboard']" />
                                            </b-btn>
                                        </div>
                                    </div>
                                </div>
                                <b-collapse :id="'error' + index" v-if="error.data && error.data.errors">
                                    <div class="mt-2">
                                        <code>
                                            <small>
                                                <ul v-for="(error, index) in error.data.errors" :key="index" class="text-danger mb-0 pl-3">
                                                    <li v-for="(item, index) in error" :key="index">{{item}}</li>
                                                </ul>
                                            </small>
                                        </code>
                                    </div>
                                </b-collapse>
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="text-muted text-nowrap" v-if="error.time">
                                    <small>{{moment(error.time).fromNow()}}</small>
                                </div>
                            </div>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </div>

            <b-alert variant="success" :show="!errors || errors && !errors.length">
                0 Errors
            </b-alert>

            <template #modal-footer>
                <b-button variant="light" @click="close">
                    Close
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.url,
.message {
    .copy-to-clipboard {
        visibility: hidden;
    }
    &:hover {
        .copy-to-clipboard {
            visibility: visible;
        }
    }
}
</style>

<script>
import Vue from 'vue'

import { mapState } from 'vuex'

import moment from 'moment'
Vue.prototype.moment = moment

export default {
    data: () => ({

    }),
    props: [
        'value',
        'publication'
    ],
    components: {

    },
    computed: {
        ...mapState({
            errors: state => state.errors.errors,
            user: state => state.user.user
        }),
        modal_id () {
            let modal_id = 'errors-modal'
            return modal_id
        },
        ordered_errors () {
            let ordered_errors = []

            if (this.errors) {
                ordered_errors = _.orderBy(this.errors, 'time', 'desc')
            }

            return ordered_errors
        }
    },
    methods: {
        clearAllErrors () {
            this.$store.commit('setErrors', [])

            this.$emit('hide')
        },
        close () {
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        }
    },
    mounted () {

    }
}
</script>
